import { render, staticRenderFns } from "./collection-summary.vue?vue&type=template&id=29cfd44a"
import script from "./collection-summary.vue?vue&type=script&lang=js"
export * from "./collection-summary.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/home/vsts/work/1/s/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('29cfd44a')) {
      api.createRecord('29cfd44a', component.options)
    } else {
      api.reload('29cfd44a', component.options)
    }
    module.hot.accept("./collection-summary.vue?vue&type=template&id=29cfd44a", function () {
      api.rerender('29cfd44a', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/views/CustomerViews/Collections/collection-summary.vue"
export default component.exports